var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.iconClass)?_c('span',[_c('font-awesome-icon',{class:`follow-up ${_vm.classes}`,attrs:{"icon":['fal', _vm.iconClass]}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }